import { useContext } from "react";
import { I18nContext, type I18nContextValue } from "../providers/I18nProvider";
import { DICT, DEFAULT_LANG } from "../lib/i18n-dict";

export function useI18n(): I18nContextValue {
  const context = useContext(I18nContext);
  if (!context) {
    // Fallback for test environments without I18nProvider
    const dict = DICT[DEFAULT_LANG];
    return {
      lang: DEFAULT_LANG,
      setLang: () => {},
      t: (key: string) => dict?.[key] ?? key,
      languages: [],
    };
  }
  return context;
}
